import { extendTheme } from "@chakra-ui/react";
import colors from "./colors";
import fonts from "./fonts";

export const wlTheme = extendTheme({
  colors: colors,
  fonts: fonts
});
